export default "__VITE_ASSET__BT18dEs9__"